import Keycloak from "keycloak-js";
import {
  clearAccessToken,
  removeTenant,
  setAccessToken,
} from "../utils/tenant";

let instance = null;
let refreshIntervalId = null;

const TOKEN_EXP_KEY = "token-exp-tm";
const REFRESH_INTERVAL_MS = 60_000;
const REFRESH_MIN_VALIDITY_SECONDS = 70;

export function getKeycloak() {
  return instance;
}

export function getToken() {
  return instance?.token;
}

export function getUsername() {
  return instance?.tokenParsed?.name ?? "";
}

export function login() {
  return instance?.login({ redirectUri: window.location.origin });
}

export function logout(options) {
  return instance?.logout(options);
}

export async function updateToken(minValiditySeconds = 5) {
  return instance.updateToken(minValiditySeconds);
}

export async function initKeycloak({ tenant, onSessionLost }) {
  instance = new Keycloak({
    url: tenant.server,
    realm: tenant.realm,
    clientId: tenant.clientId,
  });

  const authenticated = await instance.init({ onLoad: "login-required" });
  setAccessToken(instance.token);

  const tokenExpToMs = (instance.tokenParsed?.exp ?? 0) * 1000;
  localStorage.setItem(TOKEN_EXP_KEY, String(tokenExpToMs));

  const sessionLost = () => {
    if (refreshIntervalId) {
      clearInterval(refreshIntervalId);
      refreshIntervalId = null;
    }
    removeTenant();
    clearAccessToken();
    localStorage.removeItem(TOKEN_EXP_KEY);
    onSessionLost?.();
  };

  refreshIntervalId = setInterval(() => {
    instance
      .updateToken(REFRESH_MIN_VALIDITY_SECONDS)
      .catch(() => {
        console.error("Failed to refresh token, or session has expired");
        sessionLost();
      });
  }, REFRESH_INTERVAL_MS);

  instance.onTokenExpired = () => {
    instance.updateToken(0).catch(sessionLost);
  };

  instance.onAuthLogout = sessionLost;

  return { authenticated };
}
